import { selectors, useAppSelector } from "store";
export var partsPerMinuteTranslationKey = "dashboard.parts_per_minute";
export var cyclesPerMinuteTranslationKey = "dashboard.cycles_per_minute";
/*
 * The "parts per minute" target is what the calculation API cycles the
 * system at: one pick-and-place cycle per part. With one lifted box those are
 * the same thing and the readouts keep saying "Parts/min". When the tool
 * lifts several boxes at once a cycle moves all of them, so the same number
 * is labelled "Cycles/min". Only the wording changes — the parameter and the
 * request to the API are untouched.
 */
export var applicationSpeedLabels = function (liftedBoxCount) {
    var isMultiBoxLift = liftedBoxCount >= 2;
    return {
        isMultiBoxLift: isMultiBoxLift,
        perMinuteTranslationKey: isMultiBoxLift
            ? cyclesPerMinuteTranslationKey
            : partsPerMinuteTranslationKey,
    };
};
export var useApplicationSpeedLabels = function () {
    return applicationSpeedLabels(useAppSelector(selectors.selectLiftedBoxCount));
};
